<template>
    <div>
        <template v-if="crud_region === true">
            <div class="page-top mb-1 mb-3">
                <h1> Edit Region </h1>
            </div>
            <div class="global-main">
                <form @submit.prevent="editRegion">
                    <div class="form-group">
                        <label>Name</label>
                        <input v-model="form.name" type="text" name="name" class="form-control" :class="{ 'is-invalid': form.errors.has('name') }" />
                        <has-error :form="form" field="username"></has-error>
                    </div>
                    <div class="form-group">
                        <input v-model="form.name" type="hidden" name="id" class="form-control" :class="{ 'is-invalid': form.errors.has('id') }" />
                        <button :disabled="form.busy" class="btn btn-primary float-right active">Save</button>
                        <router-link to="/regions" class="btn btn-primary float-right mr-2">Cancel</router-link>
                    </div>
                </form>
            </div>
        </template>
        <template v-else-if="crud_region === null">
            <preLoader></preLoader>
        </template>
        <template v-else-if="crud_region === false">
            <notAllowed></notAllowed>
        </template>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                form : new Form({
                    id: '',
                    name: '',
                }),
                crud_region: null
            };
        },
        methods: {
            editRegion() {
                this.$Progress.start();
                this.form.put('/api/updateRegion')
                    .then(res => {
                        if(res.status == 200){
                            toast.fire({
                                type: 'success',
                                title: 'Region Updated successfully'
                            });
                            this.$router.push('/regions');
                            this.$Progress.finish();
                        }else{
                            this.$Progress.fail();
                        }
                    })
                    .catch(err => {
                        this.$Progress.fail();
                        console.log(err);
                    });
            },
            getEditRegionData(){
                axios.get('/api/editRegion/'+this.$route.params.id)
                .then(res => {
                    if(res.status == 200){
                        this.form.name = res.data.record.name;
                        this.form.id = res.data.record.id;
                        this.$Progress.finish();
                    }else{
                        this.$Progress.fail();
                    }
                })
                .catch(err => {
                    console.log(err);
                    this.$Progress.fail();
                });
            }
        },
        mounted() {
            this.$Progress.start();
			this.can('crud_region').then(result => {
                this.crud_region = result.crud_region;
            }).then(result => {
                if(this.crud_region == true){
                    this.getEditRegionData();
                    this.$Progress.finish();
                }else{
                    this.$Progress.finish();
                }
            });
        }
    }
</script>
